module.exports = __webpack_public_path__ + "img/DSC_1151.f2c5ee15.jpg";